// angular
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { NotificationProgrammingContext } from './../services/notifications.service';
import { Command } from './../../../common/params/interfaces/command.interface';

import { ProgrammingUtilsService as Utils} from './../../../common/services/utils.service';
import { QSNotificationsService, NotificationAgentType } from '../services/notifications.service';

@Component({
  templateUrl: './action.component.html'
})
export class QSNotificationsActionComponent {

  constructor(
    private _notifications: QSNotificationsService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _store: Store<{notificationsProgramming: NotificationProgrammingContext}>
  ) {
    this._route.params.subscribe((params: { agent: NotificationAgentType }) => this._notifications.setAgentType(params.agent));
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/action/action.component.ts